<script setup lang="ts">
import { FormConfig, FormValues } from "@/components/forms/types";
import { dialogEvents } from "@/data-views/dialogs";

////////////////////////////////////////////////////////////
//////////////////// VARIABLES /////////////////////////////
////////////////////////////////////////////////////////////
const loading = ref(false);
const isVisible = ref(false);
const formConfig = ref<FormConfig>({
  title: "",
  sections: [],
});
const formValues = ref<FormValues>({});
const onSubmit = ref<(formValues: FormValues) => Promise<void>>(() =>
  Promise.resolve(),
);

////////////////////////////////////////////////////////////
//////////////////// METHODS ///////////////////////////////
////////////////////////////////////////////////////////////
/**
 * Load the dialog
 */
async function load(
  config: FormConfig,
  values: FormValues,
  submit: (formValues: FormValues) => Promise<void>,
): Promise<void> {
  // Start loading
  loading.value = true;

  // Set the config
  formConfig.value = config;

  // Set the values
  formValues.value = values;

  // Set the onSubmit
  onSubmit.value = submit;

  // Stop loading
  loading.value = false;
}

async function handleSubmit(): Promise<void> {
  // Start loading
  loading.value = true;

  // Submit the form
  await onSubmit.value(formValues.value);

  // Hide
  isVisible.value = false;

  // Stop loading
  loading.value = false;
}

////////////////////////////////////////////////////////////
//////////////////// LIFECYCLE /////////////////////////////
////////////////////////////////////////////////////////////
onMounted(() => {
  window.addEventListener(dialogEvents.InputDialog.OPEN, ({ detail }: any) => {
    // Load
    void load(detail.formConfig, detail.formValues, detail.onSubmit);

    // Set the visibility to visible
    isVisible.value = true;
  });
  window.addEventListener(dialogEvents.InputDialog.CLOSE, () => {
    // Set the visibility to hidden
    isVisible.value = false;
  });
});
</script>

<template>
  <FormDialog
    :config="formConfig"
    :loading="loading"
    v-model="formValues"
    v-model:is-visible="isVisible"
    @submit="handleSubmit"
  />
</template>
